import React from 'react';
import { Icon } from './Icon.js';
export const IconNutFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m11.695,4.862l-1.865-3.23c-.404-.698-1.155-1.132-1.959-1.132h-3.742c-.804,0-1.555.434-1.959,1.133L.305,4.862c-.405.702-.405,1.574,0,2.275l1.865,3.23c.404.698,1.155,1.132,1.959,1.132h3.742c.804,0,1.555-.434,1.959-1.133l1.865-3.229c.405-.702.405-1.574,0-2.275Zm-5.695,3.138c-1.105,0-2-.895-2-2s.895-2,2-2,2,.895,2,2-.895,2-2,2Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconNutFill12.js.map